/**
 * CROEV Quiz v3 - Luma Brain scenes (round 3, 2026-10-03, after Vilo's review of v2)
 * Snippets: croev-quiz-v3-luma-scene-<kind>.liquid. Styles: croev-quiz-v3-luma-scenes.css.
 * - two_in_three: the gold underline draws on once.
 * - borrowing: visitor-paced. Beat 1 plays on entry and holds; Back / Next, the dots, a swipe on the drawing
 *   or the pinned footer button move between beats (the footer reads Next until the last beat). Each beat
 *   replays from its start state, about twice as slow as v2. Every move fires scene_beat.
 * - egg_math, label: unchanged from v2 (eggs fill, gap and arrow; the label loop drawn around the row).
 * - the loader (engine loading_step): the quote marquee runs at about 40px a second and pauses on touch.
 * - the result letter: its gold arrow draws on once.
 * The markup holds each scene's final state, so prefers-reduced-motion (or no JS) shows the final frame.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timers = [];
  function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }
  function every(fn, ms) { var t = setInterval(fn, ms); timers.push(t); return t; }
  function clear() { timers.forEach(function (t) { clearTimeout(t); clearInterval(t); }); timers = []; }
  function draws(el, on) { if (el) el.querySelectorAll('.lus-draw').forEach(function (p) { p.classList.toggle('is-drawn', !!on); }); }
  function instant(el, fn) { el.classList.add('lus-instant'); fn(); void el.getBoundingClientRect(); el.classList.remove('lus-instant'); }
  function track(name, data) { try { if (window.CroevQuizAnalytics) window.CroevQuizAnalytics.track(name, data); } catch (e) { /* no-op */ } }

  /* ---------- scene 5: two in three ---------- */
  function twoInThree(st) {
    if (reduced) { draws(st, true); return; }
    draws(st, false);
    later(function () { draws(st.querySelector('.lus2__big'), true); }, 250);
  }

  /* ---------- scene 9: borrowing ---------- */
  var NS = 'http://www.w3.org/2000/svg';
  function el(name, attrs, parent) {
    var e = document.createElementNS(NS, name);
    Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (parent) parent.appendChild(e);
    return e;
  }
  function buildBorrowing(svg) {
    if (svg.__built) return svg.__built;
    var cells = [{ cx: 86, cy: 104 }, { cx: 254, cy: 104 }], rx = 66, ry = 60, N = 24;
    var g = el('g', {}, svg);
    cells.forEach(function (c) { el('ellipse', { cx: c.cx, cy: c.cy, rx: rx - 2, ry: ry - 2, class: 'lus9__cell' }, g); });
    var wall = [], inner = [];
    cells.forEach(function (c, ci) {
      for (var i = 0; i < N; i++) {
        var a = (i / N) * Math.PI * 2;
        var gg = el('g', { class: 'lus9__mover' }, g);
        var b = el('circle', { cx: (c.cx + rx * Math.cos(a)).toFixed(1), cy: (c.cy + ry * Math.sin(a)).toFixed(1), r: 6.2, class: 'lus9__bead' }, gg);
        b.__g = gg; b.__a = a; b.__cell = ci;
        b.__popDelay = (i * 0.075 + ci * 0.45);
        wall.push(b);
      }
    });
    [[66, 86], [96, 76], [58, 118], [104, 122], [84, 102]].forEach(function (p, i) {
      var gg = el('g', { class: 'lus9__mover' }, g);
      var b = el('circle', { cx: p[0], cy: p[1], r: 4.6, class: 'lus9__bead lus9__bead--in' }, gg);
      b.__g = gg; b.__popDelay = 1.6 + i * 0.12;
      inner.push(b);
    });
    var right = [[232, 88], [262, 116], [244, 126], [270, 90], [250, 102]];
    var deep = [[226, 108], [276, 106], [252, 76], [238, 136], [264, 136]];
    var leaving = wall.filter(function (b) { return b.__cell === 0 && Math.cos(b.__a) > 0.55; }).slice(0, 5);
    svg.__built = { wall: wall, inner: inner, right: right, deep: deep, leaving: leaving };
    return svg.__built;
  }
  function moveTo(b, x, y, delay) {
    b.__g.style.transitionDelay = delay + 's';
    b.__g.style.transform = 'translate(' + (x - b.getAttribute('cx')) + 'px,' + (y - b.getAttribute('cy')) + 'px)';
  }
  /* the drawing after n beats (0..3); `play` staggers the motion of beat n itself */
  function borrowState(svg, n, play) {
    var d = buildBorrowing(svg);
    d.wall.forEach(function (b) {
      b.style.transitionDelay = (play && n === 1) ? b.__popDelay + 's' : '0s';
      b.classList.toggle('is-on', n >= 1);
      b.classList.remove('is-gold', 'is-thin');
      b.__g.style.transitionDelay = '0s'; b.__g.style.transform = '';
    });
    d.inner.forEach(function (b, i) {
      b.style.transitionDelay = (play && n === 1) ? b.__popDelay + 's' : (play && n === 2 ? (i * 0.3) + 's' : '0s');
      b.classList.toggle('is-on', n >= 1);
      b.classList.toggle('is-gold', n >= 2);
      if (n >= 2) moveTo(b, d.right[i][0], d.right[i][1], play && n === 2 ? i * 0.3 : 0);
    });
    if (n >= 3) {
      d.leaving.forEach(function (b, i) {
        b.style.transitionDelay = play ? (i * 0.3) + 's' : '0s';
        b.classList.add('is-gold');
        moveTo(b, d.deep[i][0], d.deep[i][1], play ? i * 0.3 : 0);
      });
      d.wall.forEach(function (b) { if (b.__cell === 0 && d.leaving.indexOf(b) === -1) { b.style.transitionDelay = play ? '1.2s' : '0s'; b.classList.add('is-thin'); } });
    }
  }
  function borrowUi(st, n) {
    var total = parseInt(st.getAttribute('data-beats'), 10) || 3;
    st.querySelectorAll('.lus9__cap').forEach(function (c) { c.classList.toggle('is-on', +c.getAttribute('data-beat') === n); });
    st.querySelectorAll('.lus9__dot').forEach(function (c) { var on = +c.getAttribute('data-beat') === n; c.classList.toggle('is-on', on); c.setAttribute('aria-current', on ? 'step' : 'false'); });
    var cnt = st.querySelector('[data-lus9-n]'); if (cnt) cnt.textContent = n;
    var back = st.querySelector('.lus9__btn--back'), next = st.querySelector('.lus9__btn--next');
    if (back) back.disabled = n <= 1;
    if (next) next.disabled = n >= total;
    /* the pinned footer button: Next until the last beat, then the scene's own label */
    var lab = document.querySelector('[data-cq-footerbar] [data-cq-label]') || st.querySelector('[data-cq-label]');
    if (lab) {
      if (!lab.getAttribute('data-final-label')) lab.setAttribute('data-final-label', lab.textContent);
      lab.textContent = n < total ? (st.getAttribute('data-next-label') || 'Next') : lab.getAttribute('data-final-label');
    }
    var ring = st.querySelector('.lus9__ring');
    if (reduced) draws(ring, n >= 2);
    else if (n < 2) draws(ring, false);
    else later(function () { draws(ring, true); }, n === 2 ? 900 : 0);
  }
  function goBeat(st, n, via, dir) {
    var svg = st.querySelector('[data-lus9-svg]'); if (!svg) return;
    var total = parseInt(st.getAttribute('data-beats'), 10) || 3;
    n = Math.max(1, Math.min(total, n));
    clear();
    st.__beat = n;
    if (reduced) { instant(svg, function () { borrowState(svg, n, false); }); }
    else {
      instant(svg, function () { borrowState(svg, n - 1, false); });
      later(function () { borrowState(svg, n, true); }, 80);
    }
    borrowUi(st, n);
    if (via) track('scene_beat', { step_key: st.getAttribute('data-step-key'), beat: n, direction: dir, via: via });
  }
  function borrowing(st) {
    var svg = st.querySelector('[data-lus9-svg]');
    if (!svg) return;
    buildBorrowing(svg);
    if (!st.__wired) {
      st.__wired = true;
      st.querySelectorAll('[data-lus9-move]').forEach(function (b) {
        b.addEventListener('click', function () { var d = +b.getAttribute('data-lus9-move'); goBeat(st, (st.__beat || 1) + d, 'button', d > 0 ? 'forward' : 'back'); });
      });
      st.querySelectorAll('.lus9__dot').forEach(function (dot) {
        dot.addEventListener('click', function () { var n = +dot.getAttribute('data-beat'); goBeat(st, n, 'dot', n >= (st.__beat || 1) ? 'forward' : 'back'); });
      });
      var zone = st.querySelector('[data-lus9-swipe]'), x0 = null, y0 = null;
      if (zone) {
        zone.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        zone.addEventListener('touchend', function (e) {
          if (x0 == null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goBeat(st, (st.__beat || 1) + (dx < 0 ? 1 : -1), 'swipe', dx < 0 ? 'forward' : 'back');
        }, { passive: true });
      }
    }
    st.__beat = 1;
    goBeat(st, 1, null);
  }
  /* the footer button drives the beats until the last one (capture phase: before the engine's own handler) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cq-footerbar] [data-action="continue"]');
    if (!btn) return;
    var st = document.querySelector('[data-cq-root] .cq__step.is-active[data-scene="borrowing"]');
    if (!st) return;
    var total = parseInt(st.getAttribute('data-beats'), 10) || 3;
    if ((st.__beat || 1) >= total) return;
    e.preventDefault(); e.stopImmediatePropagation();
    goBeat(st, (st.__beat || 1) + 1, 'footer', 'forward');
  }, true);

  /* ---------- scene 10: egg math (unchanged) ---------- */
  function eggGeometry(st) {
    var eggs = st.querySelector('.lus10__row--b .lus10__eggs');
    var first = eggs && eggs.querySelector('.lus10__egg');
    if (!first) return null;
    var w = first.getBoundingClientRect().width;
    var second = eggs.querySelectorAll('.lus10__egg')[1];
    var step = second ? second.getBoundingClientRect().left - first.getBoundingClientRect().left : w;
    return { w: w, step: step };
  }
  function placeGap(st) {
    var g = eggGeometry(st), gap = st.querySelector('.lus10__gap');
    if (!g || !gap) return;
    var x = function (f) { var i = Math.floor(f); return i * g.step + (f - i) * g.w; };
    var fb = parseFloat(st.getAttribute('data-fb')), fa = parseFloat(st.getAttribute('data-fa'));
    gap.style.left = (x(fb) - 3) + 'px';
    gap.style.width = (x(fa) - x(fb) + 6) + 'px';
    var arrow = st.querySelector('.lus10__arrow');
    if (arrow) arrow.style.left = ((x(fb) + x(fa)) / 2 - 14 * arrow.getBoundingClientRect().width / 64) + 'px';
  }
  function fillRow(row, t) {
    var f = parseFloat(row.getAttribute('data-f'));
    row.querySelectorAll('.lus10__egg').forEach(function (egg, i) {
      var part = Math.max(0, Math.min(1, f * t - i));
      egg.querySelector('.lus10__clip').setAttribute('width', (part * 40).toFixed(2));
    });
  }
  function eggMath(st) {
    placeGap(st);
    var a = st.querySelector('.lus10__row--a'), b = st.querySelector('.lus10__row--b');
    if (reduced) { fillRow(a, 1); fillRow(b, 1); st.classList.add('is-gap'); draws(st, true); return; }
    st.classList.add('is-playing'); st.classList.remove('is-gap'); draws(st, false);
    fillRow(a, 0); fillRow(b, 0);
    var t0 = Date.now(), ta = 1100, tb = 900, pause = 250;
    var iv = every(function () {
      var e = Date.now() - t0;
      fillRow(a, Math.min(1, e / ta));
      fillRow(b, Math.min(1, Math.max(0, (e - ta - pause) / tb)));
      if (e >= ta + pause + tb) {
        clearInterval(iv);
        st.classList.add('is-gap');
        later(function () { draws(st, true); }, 250);
      }
    }, 30);
  }

  /* ---------- scene 13: label (unchanged) ---------- */
  function placeEllipse(st) {
    var wrap = st.querySelector('.lus13__wrap'), row = st.querySelector('.lus13__row--real'), el2 = st.querySelector('.lus13__ellipse'), ar = st.querySelector('.lus13__arrow');
    if (!wrap || !row || !el2) return;
    var facts = row.offsetParent === wrap ? null : row.offsetParent;
    var top = row.offsetTop + (facts ? facts.offsetTop : 0), left = row.offsetLeft + (facts ? facts.offsetLeft : 0);
    var padX = 22, padY = -3;   /* the loop stays inside the row's borders, clear of the header above and the bars below */
    el2.style.left = (left - padX) + 'px';
    el2.style.width = (row.offsetWidth + padX * 2) + 'px';
    el2.style.top = (top - padY) + 'px';
    el2.style.height = (row.offsetHeight + padY * 2) + 'px';
    if (facts) el2.style.transformOrigin = (facts.offsetLeft + facts.offsetWidth / 2 - (left - padX)) + 'px ' + (facts.offsetTop + facts.offsetHeight / 2 - (top - padY)) + 'px';
    if (ar) {
      var k = 56 / 70, tipX = left + row.offsetWidth - 20, tipY = top - padY - 6;
      ar.style.left = (tipX - 13 * k) + 'px';
      ar.style.top = (tipY - 35 * k) + 'px';
    }
  }
  function label(st) {
    placeEllipse(st);
    if (reduced) { st.classList.add('is-in'); draws(st, true); return; }
    st.classList.add('is-playing'); st.classList.remove('is-in'); draws(st, false);
    later(function () { st.classList.add('is-in'); }, 60);
    later(function () { draws(st.querySelector('.lus13__wrap'), true); }, 650);
  }

  /* ---------- the loader: a readable marquee speed, pause on touch ---------- */
  function loader(st) {
    var tr = st.querySelector('.cq__marquee-track');
    if (!tr) return;
    var half = tr.scrollWidth / 2;
    if (half > 0) tr.style.animationDuration = Math.round(half / 40) + 's';
    var mq = st.querySelector('.cq__marquee');
    if (mq && !mq.__wired) {
      mq.__wired = true;
      mq.addEventListener('touchstart', function () { mq.classList.add('is-held'); }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (t) { mq.addEventListener(t, function () { mq.classList.remove('is-held'); }, { passive: true }); });
    }
  }

  var RUN = { two_in_three: twoInThree, borrowing: borrowing, egg_math: eggMath, label: label };

  function onStep() {
    clear();
    var root = document.querySelector('[data-cq-root]');
    if (!root) return;
    var letter = root.querySelector('.cq__step--letter.is-active');
    if (letter) { if (reduced) draws(letter, true); else { draws(letter, false); later(function () { draws(letter, true); }, 900); } return; }
    var load = root.querySelector('.cq__step.is-active[data-step-type="loading"]');
    if (load) { loader(load); return; }
    var st = root.querySelector('.cq__step.is-active[data-scene]');
    if (!st) return;
    var fn = RUN[st.getAttribute('data-scene')];
    if (fn) fn(st);
  }

  document.addEventListener('croev:quiz:step', function () { setTimeout(onStep, 0); });
  window.addEventListener('resize', function () {
    var st = document.querySelector('[data-cq-root] .cq__step.is-active[data-scene="egg_math"]');
    if (st) placeGap(st);
    var lb = document.querySelector('[data-cq-root] .cq__step.is-active[data-scene="label"]');
    if (lb) placeEllipse(lb);
  });
  if (document.readyState !== 'loading') onStep();
  else document.addEventListener('DOMContentLoaded', onStep);
})();
